<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_NewCustomerApplication')"
    :width="$selectByLang('850px', '850px', '950px')"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" :label-width="$selectByLang('140px', '140px', '180px')" label-position="left" class="customer-application-form">
      <el-row :gutter="20">
        <!-- 代码 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.cnShortName')" prop="cnShortName">
            <el-input v-model="form.cnShortName" no="cnShortName" :maxlength="64" :disabled="true" />
          </el-form-item>
        </el-col>
        <!-- 国内/国外 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_DomesticOverseas')" prop="oversea">
            <el-select v-model="form.oversea" no="oversea" style="width: 100%">
              <el-option :label="$t('CargoMsg.Cargo_Domestic')" :value="false" />
              <el-option :label="$t('CargoMsg.Cargo_International')" :value="true" />
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="20">
        <!-- 中文名称 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')" prop="chineseName">
            <el-input v-model="form.chineseName" no="chineseName" :maxlength="200" />
          </el-form-item>
        </el-col>
        <!-- 简称 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.shortName')" prop="shortName">
            <el-input v-model="form.shortName" no="shortName" :maxlength="100" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 英文名称 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.englishName')" prop="englishName">
            <el-input v-model="form.englishName" no="englishName" :maxlength="200" />
          </el-form-item>
        </el-col>
        <!-- 含海外仓 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_IncludeOverseasWarehouse')" prop="overseasWarehouse">
            <el-select v-model="form.overseasWarehouse" no="overseasWarehouse" style="width: 100%">
              <el-option :label="$t('Message.Yes')" :value="true" />
              <el-option :label="$t('Message.No')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 是否同行 -->
        <el-col :span="12">
          <el-form-item :label="$t('Partners.isPeers')" prop="peer">
            <el-select v-model="form.peer" no="peer" style="width: 100%">
              <el-option :label="$t('Message.Yes')" :value="true" />
              <el-option :label="$t('Message.No')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 客户等级 -->
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerLevel')" prop="customerTypeId">
            <el-select v-model="form.customerTypeId">
              <el-option
                v-for="(item,index) in customerTypeList"
                :key="index"
                :label="item.chineseName"
                :value="item.typeId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 地址 -->
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Addr')" prop="address">
            <el-input v-model="form.address" no="address" :maxlength="500" />
          </el-form-item>
        </el-col>
        <!-- 贸易类型 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_TradeType')" prop="tradeTypes">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_IncoTerm"
              callback-method-type="value"
              :multiple="true"
              :default-multiple-value="toArray(form.tradeTypes)"
              :callback-params="{ key:'tradeTypes' }"
              @parentCallBack="p=>{form.tradeTypes=toTxt(p.value)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 账期 -->
        <el-col :span="12">
          <el-form-item :label="$t('Partners.accountPeriod')" prop="creditDateLimited">
            <cargo-advance-select
              :default-value="form.creditDateLimited"
              :clearable="false"
              tag-name="name"
              tag-value="code"
              :static-options="creditDateLimitedList"
              @parentCallBack="p=>{form.creditDateLimited=p.value}"
            />
          </el-form-item>
        </el-col>
        <!-- 额度 -->
        <el-col :span="12">
          <el-form-item :label="$t('Partners.limit')" prop="credit">
            <el-input-number v-model="form.credit" :min="0" :controls="false" style="width: 100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 签订合同 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_SignContract2')" prop="signContract">
            <el-select v-model="form.signContract" no="signContract" style="width: 100%">
              <el-option :label="$t('Message.Yes')" :value="true" />
              <el-option :label="$t('Message.No')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 最迟签订合同日期 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_LatestContractDate')" prop="latestContractDate">
            <el-date-picker
              v-model="form.latestContractDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 角色 -->
      <el-form-item :label="$t('CargoMsg.Cargo_RuleRole')">
        <el-checkbox v-model="form.customer" :disabled="true" no="roleCustomer">
          {{ $t('Partners.customer') }}
        </el-checkbox>
      </el-form-item>
      <!-- 相关业务类型 -->
      <el-form-item :label="$t('Partners.relatedBusinessType')" prop="relatedBusinessTypes">
        <el-checkbox v-model="form.seaExport" no="seaExport">{{ $t('constant.systemConstants.SE') }}</el-checkbox>
        <el-checkbox v-model="form.seaImport" no="seaImport">{{ $t('constant.systemConstants.SI') }}</el-checkbox>
        <el-checkbox v-model="form.airExport" no="airExport">{{ $t('constant.systemConstants.AE') }}</el-checkbox>
        <el-checkbox v-model="form.airImport" no="airImport">{{ $t('constant.systemConstants.AI') }}</el-checkbox>
        <el-checkbox v-model="form.railwayExport" no="railwayExport">{{ $t('constant.systemConstants.RB') }}</el-checkbox>
        <el-checkbox v-model="form.integratedJob" no="integratedJob">{{ $t('constant.systemConstants.IE') }}</el-checkbox>
      </el-form-item>
      <!-- 对应服务人员 -->
      <el-form-item :label="$t('Partners.theCorrespondingServicePartners')">
        <div style="height: 240px">
          <company-user-container ref="companyUserContainer" action="edit" />
        </div>
      </el-form-item>
      <!-- 信用额度自测表 -->
      <el-form-item :label="$t('CargoMsg.Cargo_CreditControlSelfAssessment')" prop="creditSelfAssessment">
        <div class="upload-file-row">
          <template v-if="hasUploadedFile('creditSelfAssessment')">
            <span class="upload-file-name">{{ getUploadedFileName('creditSelfAssessment') }}</span>
            <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveUpload('creditSelfAssessment')" />
          </template>
          <el-button v-else size="small" type="primary" @click="handleUpload('creditSelfAssessment')">
            {{ $t('CargoMsg.Cargo_Upload') }}
          </el-button>
        </div>
      </el-form-item>
      <!-- 客户档案 -->
      <el-form-item :label="$t('CargoMsg.Cargo_CustomerFile')" prop="customerProfile">
        <div class="upload-file-row">
          <template v-if="hasUploadedFile('customerProfile')">
            <span class="upload-file-name">{{ getUploadedFileName('customerProfile') }}</span>
            <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveUpload('customerProfile')" />
          </template>
          <el-button v-else size="small" type="primary" @click="handleUpload('customerProfile')">
            {{ $t('CargoMsg.Cargo_Upload') }}
          </el-button>
        </div>
      </el-form-item>
      <!-- 客户托书 -->
      <el-form-item :label="$t('CargoMsg.Cargo_CustomerConsignmentNote')" prop="customerCommission">
        <div class="upload-file-row">
          <template v-if="hasUploadedFile('customerCommission')">
            <span class="upload-file-name">{{ getUploadedFileName('customerCommission') }}</span>
            <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveUpload('customerCommission')" />
          </template>
          <el-button v-else size="small" type="primary" @click="handleUpload('customerCommission')">
            {{ $t('CargoMsg.Cargo_Upload') }}
          </el-button>
        </div>
      </el-form-item>
      <!-- 申请原因 -->
      <el-form-item :label="$t('CargoMsg.Application_Reason')" prop="applicationReason">
        <el-input
          v-model="form.applicationReason"
          type="textarea"
          :rows="4"
          :maxlength="500"
          show-word-limit
          no="applicationReason"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto; width: fit-content;">
      <el-button type="primary" no="submit" @click="handleSubmit">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="uploadSuccess"
    />
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CompanyApplication } from '@/class/model/mdm/CompanyApplication'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import DropUploader from '@/components/Cargo/Common/DropUploader.vue'
import CompanyUserContainer from '../companyUserContainer.vue'
import { Project } from '@/class/model/pm/Project'
import { addCompanyApplicationFunc, checkCompanyExistFunc } from '@/api/company'

export default {
  name: 'CompanyApplicationDialog',
  components: { DropUploader, cargoCloudFileUpload, CargoAdvanceSelect, CompanyUserContainer },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    // 自定义验证规则
    const validateCredit = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      } else {
        callback()
      }
    }
    const validateRelatedBusinessTypes = (rule, value, callback) => {
      if (!(this.form.seaExport || this.form.seaImport || this.form.airExport || this.form.airImport || this.form.railwayExport || this.form.integratedJob)) {
        callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelectBusinessType')))
      } else {
        callback()
      }
    }
    const validateTradeTypes = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(this.$t('CargoMsg.Cargo_SelectTradeType')))
      } else {
        callback()
      }
    }
    const validateFile = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelectFile')))
      } else {
        callback()
      }
    }
    return {
      innerVisible: false,
      form: new CompanyApplication().fillDefaultValue().getData(),
      selectTypeNames: TYPE_NAMES,
      companyUserPartner: {
        uuid: '',
        companyUsers: [],
        deletedCompanyUserKeys: []
      },
      rules: {
        oversea: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        chineseName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        cnShortName: [
          { required: false, trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        englishName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        overseasWarehouse: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        peer: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        customerTypeId: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        credit: [
          { required: true, validator: validateCredit, trigger: 'blur' }
        ],
        signContract: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        latestContractDate: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        relatedBusinessTypes: [
          { required: true, validator: validateRelatedBusinessTypes, trigger: 'change' }
        ],
        tradeTypes: [
          { required: true, validator: validateTradeTypes, trigger: 'change' }
        ],
        creditSelfAssessment: [
          { required: true, validator: validateFile, trigger: 'change' }
        ],
        customerProfile: [
          { required: true, validator: validateFile, trigger: 'change' }
        ],
        customerCommission: [
          { required: true, validator: validateFile, trigger: 'change' }
        ]
      },
      customerTypeList: [],
      creditDateLimitedList: [{ code: 0, name: '票结' }, { code: 30, name: '30天' }, { code: 45, name: '45天' }, { code: 60, name: '60天' }, { code: 90, name: '90天' }],
      uploadedFiles: {
        creditSelfAssessment: [],
        customerProfile: [],
        customerCommission: []
      },
      cloudFile: {
        visible: false,
        type: 'creditSelfAssessment',
        job: new Project(),
        lob: 'allLob'
      }
    }
  },
  computed: {
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.initData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.customerTypeList = getCacheListByKey(TYPE_NAMES.basic_data_CustomerType)
    if (this.innerVisible) {
      this.initCompanyUserContainer()
    }
  },
  methods: {
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    async initData() {
      // 重置表单
      this.resetForm()
      this.initCompanyUserContainer()
    },
    resetForm() {
      this.form = {
        oversea: false,
        customer: true,
        ifCustomer: true,
        ifSupplier: false,
        chineseName: '',
        englishName: '',
        shortName: '',
        cnShortName: '',
        address: '',
        overseasWarehouse: false,
        peer: false,
        tradeTypes: '',
        customerTypeId: 1,
        creditDateLimited: 0,
        credit: 0,
        signContract: false,
        latestContractDate: '',
        // 业务类型相关字段
        seaExport: false,
        seaImport: false,
        airExport: false,
        airImport: false,
        railwayExport: false,
        integratedJob: false,
        // 角色类型相关字段
        settlementAgent: false,
        bookingAgent: false,
        seaCmpAgent: false,
        overseaAgent: false,
        designationAgent: false,
        localAgent: false,
        seaCmp: false,
        airCmp: false,
        customsBroker: false,
        warehouse: false,
        truckCmp: false,
        signBillPlaceCompany: false,
        shipper: false,
        consignee: false,
        notify: false,
        portAgent: false,
        forwardingAgent: false,
        terminalCompany: false,
        loadingPlaceCompany: false,
        dischargePortCompany: false,
        destinationPortCompany: false,
        tradersSign: false,
        factorySign: false,
        other: false,
        // 附件相关字段
        creditSelfAssessment: '',
        customerProfile: '',
        customerCommission: '',
        // 审批相关字段
        applicationReason: ''
      }
      this.uploadedFiles = {
        creditSelfAssessment: [],
        customerProfile: [],
        customerCommission: []
      }
      this.companyUserPartner = {
        uuid: '',
        companyUsers: [],
        deletedCompanyUserKeys: []
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    initCompanyUserContainer() {
      this.$nextTick(() => {
        if (this.$refs.companyUserContainer && this.$refs.companyUserContainer.onshow) {
          this.$refs.companyUserContainer.onshow(this.companyUserPartner)
        }
      })
    },
    // 打开文件上传
    handleUpload(fileType) {
      this.cloudFile.type = fileType
      this.cloudFile.visible = true
    },
    hasUploadedFile(fileType) {
      return !!(this.form[fileType] && this.form[fileType].length > 0)
    },
    getUploadedFileName(fileType) {
      const files = (this.uploadedFiles && this.uploadedFiles[fileType]) || []
      const names = files.map(f => f && f.fileName).filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveUpload(fileType) {
      this.form[fileType] = ''
      if (this.uploadedFiles && this.uploadedFiles[fileType]) {
        this.uploadedFiles[fileType] = []
      }
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) {
          this.$refs.form.clearValidate(fileType)
        }
      })
    },
    async uploadSuccess(data) {
      try {
        const list = []
        const fileInfoList = []
        for (const item of data) {
          if (item.fileId) {
            list.push(item.fileId)
            fileInfoList.push({
              fileId: item.fileId,
              fileName: item.fileName || item.name || ''
            })
          }
        }
        if (this.cloudFile.type === 'creditSelfAssessment') {
          this.form.creditSelfAssessment = list.join(',')
          this.uploadedFiles.creditSelfAssessment = fileInfoList
        } else if (this.cloudFile.type === 'customerProfile') {
          this.form.customerProfile = list.join(',')
          this.uploadedFiles.customerProfile = fileInfoList
        } else if (this.cloudFile.type === 'customerCommission') {
          this.form.customerCommission = list.join(',')
          this.uploadedFiles.customerCommission = fileInfoList
        }
        this.$nextTick(() => {
          if (this.$refs.form && this.$refs.form.validateField) {
            this.$refs.form.validateField(this.cloudFile.type)
          }
        })
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    // 提交表单
    async handleSubmit() {
      console.log('form------------', this.form)
      this.$refs.form.validate(async(valid) => {
        if (!valid) {
          return false
        }
        const companyUsers = (this.companyUserPartner.companyUsers || []).filter(item => item && item.userId)
        if (companyUsers.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectServicePersonnel'))
          return
        }
        const submitForm = {
          ...this.form,
          companyUsers: this.companyUserPartner.companyUsers,
          deletedCompanyUserKeys: this.companyUserPartner.deletedCompanyUserKeys
        }
        const payload = {
          branchId: 1,
          chineseName:
          this.form.chineseName,
          englishName: this.form.englishName,
          isCustomer: true,
          ...(this.form.cnShortName ? { cnShortName: this.form.cnShortName } : {})
        }
        const checkRes = await checkCompanyExistFunc(payload)
        if (checkRes && checkRes.ok && checkRes.data) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyExistsCannotSubmit', [checkRes.data]))
          return
        }
        const loading = getLoading4Cxt(this)
        try {
          const res = await addCompanyApplicationFunc(submitForm)
          if (res.ok) {
            this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
            this.innerVisible = false
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_SubmitException'))
          }
        } finally {
          loading.close()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customer-application-form {
  ::v-deep .el-form-item {
    margin-bottom: 15px !important;
  }
}

::v-deep .el-form-item__label {
  font-weight: 500;
}

::v-deep .el-checkbox-group {
  .el-checkbox {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}

::v-deep .el-textarea {
  .el-textarea__inner {
    font-family: inherit;
  }
}

.upload-file-row {
  display: flex;
  align-items: center;
}

.upload-file-name {
  max-width: 560px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-remove {
  padding: 0 4px;
  margin-left: 6px;
  line-height: 1;
}
</style>
